import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";
import Btn from "../../../../Components/Buttons/Btn";

const Add = () => {
  const [input, setInput] = useState({
    device_id: "",
    sim_card_no: "",
    imei: "",
    device_type_id: "",
    mac_address: ""
  });
  
  
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const request = useAxios();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateInputs = () => {
    // Required field validation
    if (!input.device_id.trim()) {
      setError("Device ID is required");
      return false;
    }

    // Device ID should be numeric (based on your example)
    if (!/^\d+$/.test(input.device_id)) {
      setError("Device ID must contain only numbers");
      return false;
    }

    // SIM card validation (if required)
    if (input.sim_card_no && !/^\d+$/.test(input.sim_card_no)) {
      setError("SIM card number must contain only numbers");
      return false;
    }

    // IMEI validation (if required)
    if (input.imei && !/^\d+$/.test(input.imei)) {
      setError("IMEI must contain only numbers");
      return false;
    }

    // MAC address format validation
    if (input.mac_address && !/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.test(input.mac_address)) {
      setError("MAC address must be in format like 00:1A:2B:3C:4D:5E");
      return false;
    }

    setError(null);
    return true;
  };

  const handleSubmit = async () => {
    if (!validateInputs()) return;

    try {
      const res = await request({
        method: "POST",
        url: "devices/add",
        body: {
          device_id: input.device_id,
          sim_card_no: input.sim_card_no,
          imei: input.imei,
          device_type_id: input.device_type_id,
          mac_address: input.mac_address
        },
      });

      if (res === "error") {
        setError("Failed to add device. Please try again.");
        return;
      }
      
      navigate("/dashboard/devices");
    } catch (err) {
      setError(err.message || "An error occurred while adding the device");
    }
  };

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12">
      <h3 className="text-center text-xl font-semibold">Add Device</h3>
      
      {error && (
        <div className="mt-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}
      
      <div className="mt-4 space-y-4">
        {/* Device ID */}
        <div className="flex flex-col gap-1">
          <label htmlFor="device_id" className="text-sm font-medium">
            Device ID *
          </label>
          <input
            id="device_id"
            name="device_id"
            type="text"
            value={input.device_id}
            onChange={handleChange}
            className="border rounded p-2"
            placeholder="Enter device identification number (e.g., 488634209)"
            required
          />
        </div>

        {/* Device Type and SIM Card Number */}
        <div className="flex gap-5 max-md:flex-col">
          <div className="flex-1 flex flex-col gap-1">
            <label htmlFor="device_type_id" className="text-sm font-medium">
              Device Type ID
            </label>
            <input
              id="device_type_id"
              name="device_type_id"
              type="text"
              value={input.device_type_id}
              onChange={handleChange}
              className="border rounded p-2"
              placeholder="Enter device type (e.g., 500)"
            />
          </div>
          <div className="flex-1 flex flex-col gap-1">
            <label htmlFor="sim_card_no" className="text-sm font-medium">
              SIM Card Number
            </label>
            <input
              id="sim_card_no"
              name="sim_card_no"
              type="text"
              value={input.sim_card_no}
              onChange={handleChange}
              className="border rounded p-2"
              placeholder="Enter SIM card number (e.g., 0794916146)"
            />
          </div>
        </div>

        {/* IMEI Number and MAC Address */}
        <div className="flex gap-5 max-md:flex-col">
          <div className="flex-1 flex flex-col gap-1">
            <label htmlFor="imei" className="text-sm font-medium">
              IMEI Number
            </label>
            <input
              id="imei"
              name="imei"
              type="text"
              value={input.imei}
              onChange={handleChange}
              className="border rounded p-2"
              placeholder="Enter IMEI number (e.g., 23987624223)"
            />
          </div>
          <div className="flex-1 flex flex-col gap-1">
            <label htmlFor="mac_address" className="text-sm font-medium">
              MAC Address
            </label>
            <input
              id="mac_address"
              name="mac_address"
              type="text"
              value={input.mac_address}
              onChange={handleChange}
              className="border rounded p-2"
              placeholder="Enter MAC address (e.g., 00:1A:2B:3C:4D:5E)"
            />
          </div>
        </div>
      </div>

      <div className="mt-6 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/devices")}>Back</Btn>
        <Btn onClick={handleSubmit}>Submit</Btn>
      </div>
    </div>
  );
};

export default Add;